
declare var $: any;

export function doAnimate() {
  setTimeout(function () {
    $('.jb_preloader').addClass('loaded');
  }, 1000);
}
